import { mixed, object, string } from "yup"
import { ID } from "../yup.common"
const bankModel = object({
  id: ID,
  accountNumber: string().label("Account Number"),
  ifscCode: string().label("IFSC Code"),
  accountHolderName: string().label("Account Holder"),
  bank: mixed().label("Bank"),
  branchName: string().label("Branch"),
})

export default bankModel
